import { PORTAL_HOME_ROUTE } from "@/lib/portal/portal-routes";
import { withBasePath } from "@/lib/portal/base-path";

/** Slice 6 Request access form route. */
export const GLOFOX_REQUEST_ACCESS_HREF = "/glofox/access-request";

/**
 * Main-compatible route: legacy Request access form when the flag is off,
 * Markdoc help guide when it is on.
 */
export const GLOFOX_REQUEST_ACCESS_DOCS_ROUTE = "/glofox/request-access";

/** Static Redoc artifact used by the main-compatible experience. */
export const GLOFOX_LEGACY_API_REFERENCE_HREF =
  "/glofox/api/openapi-reference.html";
/** @deprecated Legacy name retained for the main-compatible search index. */
export const GLOFOX_API_REFERENCE_HREF = GLOFOX_LEGACY_API_REFERENCE_HREF;

export function getGlofoxLegacyApiReferenceHref(): string {
  return withBasePath(GLOFOX_LEGACY_API_REFERENCE_HREF);
}
/** @deprecated Use only inside the main-compatible legacy experience. */
export const getGlofoxApiReferenceHref = getGlofoxLegacyApiReferenceHref;

const GLOFOX_AUTH_ROUTES = [PORTAL_HOME_ROUTE, "/login"] as const;

export function resolveGlofoxTopNavActive(pathname: string | null): {
  docs: boolean;
  apiReference: boolean;
  requestAccess: boolean;
} {
  if (!pathname) {
    return { docs: false, apiReference: false, requestAccess: false };
  }

  if (GLOFOX_AUTH_ROUTES.includes(pathname as (typeof GLOFOX_AUTH_ROUTES)[number])) {
    return { docs: false, apiReference: false, requestAccess: false };
  }

  if (
    pathname === "/glofox/api-reference" ||
    pathname === GLOFOX_LEGACY_API_REFERENCE_HREF
  ) {
    return { docs: false, apiReference: true, requestAccess: false };
  }

  if (
    pathname === GLOFOX_REQUEST_ACCESS_HREF ||
    pathname === GLOFOX_REQUEST_ACCESS_DOCS_ROUTE
  ) {
    return { docs: false, apiReference: false, requestAccess: true };
  }

  if (pathname.startsWith("/glofox")) {
    return { docs: true, apiReference: false, requestAccess: false };
  }

  return { docs: false, apiReference: false, requestAccess: false };
}
